{
  "fr": {
    "company": {
      "noMembership": {
        "card1": {
          "heading": "Activer l'accès au groupe de licences",
          "description": "Votre établissement a déjà une licence ? Entrez le code d'activation à 8 chiffres pour activer votre accès."
        },
        "card2": {
          "heading": "Pas encore de licence ?",
          "description": "Avec une licence pour votre école ou établissement éducatif, vous pouvez utiliser fobizz avec vos collègues. Astuce : Une licence est souvent rentable dès 5 personnes !",
          "groupLicenseLink": "En savoir plus sur la licence de groupe",
          "consultationLink": "Prendre rendez-vous pour une consultation"
        }
      },
      "shell": {
        "school": "Mon école",
        "workshops": "Ateliers internes",
        "material": "Mon matériel",
        "certificate": "Certificat",
        "administration": "Gestion des licences",
        "adminInfo": "Actualités",
        "adminMemberships": "Membres et licence",
        "adminEvaluations": "Évaluation",
        "adminLegals": "Mentions légales",
        "internal": "fobizz interne",
        "selectSchool": "Choisir une école",
        "switchSchool": "Changer de vue",
        "selectGroup": "Sélectionner la période"
      },
      "overview": {
        "endedAlert": "La durée du groupe est terminée. Veuillez nous contacter.",
        "internalAnnouncements": "Annonces internes",
        "internalAnnouncementsAdminInstructions": "En tant que personne de contact de ce groupe de licences, vous pouvez laisser des recommandations individuelles dans cette section.",
        "editAnnouncements": "Modifier les annonces internes",
        "saveAnnouncements": "Mettre à jour le message",
        "cancelAnnouncements": "Annuler",
        "selectedCourses": "Recommandations",
        "license": "Ma licence scolaire",
        "yourContact": "Votre interlocuteur est | Vos interlocuteurs sont",
        "licenseHint": "Vous trouverez des informations sur vos licences sous <a href=\"/profile/licenses\" class=\"fw-semibold\">Mes licences</a>."
      },
      "workshops": {
        "heading": "Ateliers internes",
        "paragraph": "Apprenez avec votre équipe lors de nos ateliers et conférences internes.",
        "link": "Découvrir les offres internes",
        "current": "Ateliers actuels",
        "past": "Ateliers passés"
      },
      "certificate": {
        "congratulations": "Félicitations !",
        "courseCompleted": "Vous avez terminé avec succès la qualification supplémentaire.",
        "downloadPrompt": "Téléchargez votre certificat maintenant.",
        "surveyPrompt": "Votre avis est très important pour nous. Veuillez nous donner un bref retour sur la qualification supplémentaire.",
        "surveyLink": "Donner un feedback",
        "downloadLink": "Télécharger"
      },
      "material": {
        "heading": "Matériel pédagogique",
        "fields": {
          "title": "Thème",
          "url": "URL de mon résultat dans les outils fobizz",
          "acceptShared": "Oui, j'accepte de partager mes fichiers avec fobizz et d'autres enseignants sur la plateforme fobizz."
        },
        "urlHelp": "Soumettez ici votre matériel pédagogique. Utilisez le modèle pour présenter et intégrer vos contenus. Important : Partagez le lien de prévisualisation.",
        "submit": "Soumettre le matériel",
        "edit": "Modifier",
        "back": "Retour",
        "confirmationHint": "Votre projet a été reçu avec succès. Aucune confirmation de réception supplémentaire ne sera envoyée par e-mail."
      },
      "adminLegals": {
        "heading": "Mentions légales"
      },
      "adminReports": {
        "heading": "Inscriptions",
        "allLicensesEnrollments": "Inscription via toutes les licences de cet établissement | Inscriptions via toutes les licences de cet établissement",
        "licenseEnrollments": "Inscription via cette licence | Inscriptions via cette licence",
        "topic": "Titre de la formation",
        "count": "Nombre"
      },
      "adminEvaluations": {
        "heading": "Évaluation",
        "intro": "Vous trouverez ici une évaluation résumée des retours au sein de ce groupe.",
        "noFeedback": "Il n'y a pas encore assez de retours pour une évaluation des formations. Veuillez patienter un peu.",
        "rating": "Comment les formations ont-elles été évaluées en moyenne ?",
        "noRating": "Aucune évaluation par étoiles disponible.",
        "recommendationScore": "Quel est le taux moyen de recommandation de fobizz ?",
        "noRecommendationScore": "Aucun taux de recommandation disponible.",
        "publicComment": "Que disent les membres des formations ?",
        "publicCommentTooltip": "Bon à savoir : Les avis sont donnés volontairement. Les avis publics sont écrits par peu de personnes.",
        "noPublicComment": "Aucun avis disponible.",
        "metabaseDashboard": "Tableau de bord des évaluations Metabase",
        "schoolFilter": {
          "label": "Filtrer par école",
          "allSchools": "Toutes les écoles"
        }
      },
      "adminMemberships": {
        "heading": "Membres et licence",
        "inviteMembers": "Inviter des membres",
        "manageMembers": "Gérer les membres",
        "searchPlaceholder": "Nom ou e-mail...",
        "search": "Rechercher...",
        "copySuccess": "Lien copié !",
        "members": "Membre | Membres",
        "summary": {
          "groupAdmin": "Coordinateurs fobizz",
          "manageAdmins": "Gérer les admins",
          "orderEndsAt": "Fin de la licence scolaire",
          "package": "Pack de licences",
          "requestMoreLicenses": "Demander d'autres licences"
        },
        "activationCode": {
          "title": "Code d'activation pour les nouveaux membres",
          "description": "Avec ce code, tous les collègues peuvent rejoindre ce groupe de licences via {url}.",
          "copyButton": "Copier le lien incluant le code"
        },
        "invitationOptions": {
          "title": "Autres options pour inviter de nouveaux membres dans le groupe :",
          "emailCard": "Invitation par mail",
          "posterCard": "Imprimer l'affiche",
          "linkCard": "Copier le lien incluant le code"
        },
        "table": {
          "name": "Nom",
          "email": "Adresse e-mail",
          "status": "Statut",
          "createdAt": "Rejoint le",
          "actions": "Actions"
        },
        "actions": {
          "extend": "Prolonger",
          "remove": "Supprimer"
        },
        "confirm": {
          "extend": {
            "title": "Prolonger la durée ?",
            "text": "La durée pour {name} sera prolongée. Une prolongation correspond à une licence."
          },
          "remove": {
            "title": "Supprimer le membre ?",
            "text": "Cette action est irréversible. {name} sera retiré·e du groupe et perdra l'accès à la licence scolaire."
          }
        },
        "error": {
          "actionFailed": "L'action n'a pas pu être exécutée. Un rechargement de la page affichera l'état actuel.",
          "invitationFailed": "L'invitation n'a pas pu être envoyée. Un rechargement de la page affichera l'état actuel."
        },
        "pagination": {
          "previous": "Retour",
          "next": "Suivant",
          "page": "Page {current} sur {total}"
        },
        "emailModal": {
          "title": "Envoyer une invitation par e-mail",
          "placeholder": "Entrer toutes les adresses e-mail",
          "hint": "Entrez les adresses e-mail de toutes les personnes qui doivent recevoir une invitation.",
          "helpInvalidAddresses": "Les adresses invalides seront marquées en rouge.",
          "helpMailingLists": "Les adresses de distribution ne conviennent pas.",
          "submit": "Envoyer"
        }
      },
      "license": {
        "courses": {
          "title": "Licence scolaire de formation continue",
          "description": "Accès à toutes les formations fobizz, y compris les formations IA",
          "linkLabel": "Vers le catalogue de formations"
        },
        "tools": {
          "title": "Licence scolaire d'outils",
          "description": "Accédez aux outils fobizz pour l'enseignement, y compris les outils IA et les classes IA pour les élèves",
          "linkLabel": "Licence scolaire d'outils"
        },
        "toTeach": {
          "title": "Licence scolaire to teach",
          "description": "Accéder à to teach : Préparation de cours différenciable et matériel pour le personnel",
          "linkLabel": "Licence scolaire to teach"
        },
        "status": {
          "active": "actif",
          "trial": "Licence d'essai",
          "exceeded": "Expiré",
          "nonActive": "non actif",
          "confirmed": "confirmé"
        },
        "activeUntil": "Accès valide jusqu'au",
        "activeFrom": "Accès valide du {startDate} au {endDate}",
        "generalActiveUntil": "Licence valide jusqu'au",
        "upgradeText": "Ajouter pour {months} mois :",
        "requestUpgrade": "Demander une extension",
        "renewalHeadline": "Avis de prolongation",
        "renewalText": "Une prolongation est déjà réservée pour le groupe \"{groupName}\". La nouvelle licence pour {licenses} commence à partir du {startsAt}."
      },
      "membershipExceeded": {
        "member": {
          "heading": "Votre licence est malheureusement terminée.",
          "paragraph": "Parlez à la personne de contact de votre école pour savoir comment vous pouvez continuer à utiliser fobizz en tant qu'école.",
          "paragraphWithContact": "Parlez avec l'interlocuteur de votre école ({contactNames}) et renseignez-vous sur la manière dont vous pouvez continuer à utiliser fobizz en tant qu'école. | Parlez avec les interlocuteurs de votre école ({contactNames}) et renseignez-vous sur la manière dont vous pouvez continuer à utiliser fobizz en tant qu'école.",
          "hintText": "Astuce : Vous trouverez ici des informations sur",
          "hintLink": "les abonnements individuels",
          "hintSuffix": "pour un usage personnel."
        },
        "admin": {
          "heading": "Votre licence est malheureusement terminée.",
          "paragraph": "En tant que personne de contact pour l'école, vous pouvez toujours visiter le {reportsLink}. Vous pouvez également {extendLink}.",
          "reportsLink": "Espace admin 🤓",
          "extendLink": "Prolonger la licence scolaire"
        },
        "salesContact": {
          "heading": "Bienvenue dans l'espace admin de votre école",
          "textPrefix": "Je suis à votre disposition pour toute question concernant votre licence scolaire. Vous pouvez me joindre à",
          "textMiddle": "Si vous choisissez ici un",
          "calendarLink": "rendez-vous téléphonique",
          "textSuffix": ", je vous rappellerai."
        }
      },
      "csv": "Exporter CSV",
      "print": "Imprimer",
      "platformStats": {
        "allEnrollmentsCount": "Inscription via toutes les licences | Inscriptions via toutes les licences",
        "membershipsCount": "Membre | Membres",
        "continueUsingPart": "veulent continuer à utiliser fobizz"
      },
      "toolsStats": {
        "digitalTools": "outils utilisés et matériel créé",
        "pinboardsAndTeacherboards": "Tableaux d'affichage et tableaux numériques",
        "wordcloudsAndWebsites": "Nuages de mots et sites web",
        "worksheetsAndSurveys": "Fiches d'exercices et sondages",
        "texteditor": "Document texte | Documents texte",
        "audiorecords": "Enregistrements audio",
        "screenAndVideorecorder": "Enregistrements vidéo",
        "linksAndFilesharing": "Liens courts et fichiers",
        "aiTools": "Prompts IA envoyés",
        "sharedSpaces": "Classes IA créées",
        "sharedSpaceLinkInviteesCount": "Élèves dans les classes IA"
      },
      "subscriptionAlert": {
        "text": "Vous trouverez des informations sur vos abonnements et licences personnels sous",
        "linkLabel": "Mes licences"
      }
    }
  }
}
